import { fileDownload } from 'Admin/Component/AdFunc'
import '_Asset/css/User/Page/UiComponent/table.css'

const Table = () => {
  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>Table <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
      </div>

      <div className="useWay">
        <h2>How to use the Table kit</h2>
        <p>Click table to copy and paste where you want to use it.</p>
        <p>Essential Class: <span>table</span></p>
        <p>Ex. class="<span>table list_1</span>"</p>
      </div>

      <div className="layoutCont">
        <p className="copyInfo"><i className="icofont-exclamation-circle"></i>테이블을 눌러 태그를 복사 할 수 있습니다.</p>
        <div className="tit">
          <h2>Table List 1</h2>
          <p>Class: [table, list_1]</p>
        </div>

        <div className="contWrap">
          <div className="table list_1">
            <table>
              <thead>
                <tr>
									<th className="check"><input type="checkbox"></input></th>
                  <th>ID<i className="icofont-rounded-down"></i></th>
                  <th>Start Date<i className="icofont-rounded-down"></i></th>
                  <th>State<i className="icofont-rounded-down"></i></th>
                  <th>State Age<i className="icofont-rounded-down"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr>
									<td><input type="checkbox"></input></td>
                  <td>12</td>
                  <td>29-05-2022</td>
                  <td>QUERIED</td>
                  <td>5 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>13</td>
                  <td>29-05-2022 <br />29-05-2022 </td>
                  <td>PAID</td>
                  <td>2 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>14</td>
                  <td>29-05-2022</td>
                  <td>AWAITING TIMESHEETS</td>
                  <td>12 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>15</td>
                  <td>29-05-2022</td>
                  <td>VOID</td>
                  <td>2 days ago</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* No Data table list_1 */}
					<div className="table list_1">
            <table>
              <thead>
                <tr>
									<th className="check"><input type="checkbox"></input></th>
                  <th>ID<i className="icofont-rounded-down"></i></th>
                  <th>Start Date<i className="icofont-rounded-down"></i></th>
                  <th>State<i className="icofont-rounded-down"></i></th>
                  <th>State Age<i className="icofont-rounded-down"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr>
									<td colSpan="5">
                    <div className="noData">
										  <i className="icofont-warning-alt"></i>
										  <p>데이터가 존재하지 않습니다.</p>
                    </div>
									</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

			<div className="layoutCont">
        <div className="tit">
          <h2>Table List 2</h2>
          <p>Class: [table, list_2]</p>
        </div>

        <div className="contWrap">
          <div className="table list_2">
            <table>
              <thead>
                <tr>
									<th className="check"><input type="checkbox"></input></th>
                  <th>ID<i className="icofont-rounded-down"></i></th>
                  <th>Start Date<i className="icofont-rounded-down"></i></th>
                  <th>State<i className="icofont-rounded-down"></i></th>
                  <th>State Age<i className="icofont-rounded-down"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr>
									<td><input type="checkbox"></input></td>
                  <td>12</td>
                  <td>29-05-2022</td>
                  <td>QUERIED</td>
                  <td>5 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>13</td>
                  <td>29-05-2022 <br />29-05-2022 </td>
                  <td>PAID</td>
                  <td>2 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>14</td>
                  <td>29-05-2022</td>
                  <td>AWAITING TIMESHEETS</td>
                  <td>12 hours ago</td>
                </tr>
								<tr>
									<td><input type="checkbox"></input></td>
                  <td>15</td>
                  <td>29-05-2022</td>
                  <td>VOID</td>
                  <td>2 days ago</td>
                </tr>
              </tbody>
            </table>
          </div>
					
					{/* No Data table list_2 */}
					<div className="table list_2">
            <table>
              <thead>
                <tr>
									<th className="check"><input type="checkbox"></input></th>
                  <th>ID<i className="icofont-rounded-down"></i></th>
                  <th>Start Date<i className="icofont-rounded-down"></i></th>
                  <th>State<i className="icofont-rounded-down"></i></th>
                  <th>State Age<i className="icofont-rounded-down"></i></th>
                </tr>
              </thead>
              <tbody>
                <tr>
									<td colSpan="5">
                    <div className="noData">
										  <i className="icofont-warning-alt"></i>
										  <p>데이터가 존재하지 않습니다.</p>
                    </div>
									</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Table